<template>
  <div class="w-full border-t border-gray-100 border-solid border-0 mt-4 pt-3">
    <h1> Latest Books</h1>
    <Table
            :dataSource="LatestBooks"
            :columns="columns"
            :pagination="false"
          >
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'title'">
               <div class="sentence-cell">
                <span class="sentence-text">{{ record.title }}</span>
                </div>
              </template>
              <template v-if="column.key === 'image'">
                <div class="sentence-cell">
                   <img :src="record.image" alt="book image" class="h-[10rem] w-[8rem]" @error="handleImageError"/>
                </div>
              </template>
               <template v-if="column.key === 'publish_date'">
                    <p> {{ record.publish_date }}</p>
              </template>

               <template v-if="column.key === 'status'">
                    <p> {{ record.status }}</p>
              </template>
            </template>
    </Table>
  </div>
</template>

<script>
import { Table } from 'ant-design-vue';

export default {
  components: {
    Table,
  },
  data() {
    return {
      pageNum: 1,
      perPage: 15,
      columns: [
        {
          title: 'Book',
          dataIndex: 'title',
          key: 'title',
        },
        {
          title: 'Image',
          dataIndex: 'image',
          key: 'image',
        },
        {
          title: 'Publish_date',
          dataIndex: 'publish_date',
          key: 'publish_date',
        },
        {
          title: 'status',
          dataIndex: 'status',
          key: 'status',
        },
      ],
    };
  },
  watch: {},
  props: {
    LatestBooks: {
      type: Object,
      default: null,
    },
  },
  computed: {},
  methods: {
    handleImageError(e) {
      e.target.src = '@/asswts/images/dash/social.png'; // Set a fallback image
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped></style>
